/* localization-form.js — sélecteurs pays/devise et langue
   13/10/2026 (Soleil d'Or) : la liste des pays n'est plus écrite dans la page.
   Une <ul data-sdo-pays="…"> vide est remplie au survol du bouton ou à l'ouverture,
   depuis templates/search.sdo-pays.liquid. Les clics sur les pays passent par
   délégation : ils fonctionnent aussi pour les éléments insérés après coup.
   Sans attribut data-sdo-pays, le comportement est celui d'origine. */
if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        parentClass: this.parentElement.className,
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.localization-list'),
        inputSearch: this.querySelector('#localization-search-input'),
        closeButton: this.querySelector('.modal__close-button'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.onBodyClick = this.handleBodyClick.bind(this);
      this.elements.closeButton.addEventListener('click', this.hidePanel.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      if (this.elements.inputSearch) {
        this.elements.inputSearch.addEventListener('keyup', this.filter.bind(this));
      }
      this.addEventListener('click', (event) => {
        const item = event.target.closest('a[data-value]');
        if (item && this.contains(item)) this.onItemClick(event, item);
      });
      if (this.querySelector('ul[data-sdo-pays]')) {
        const precharger = () => this.chargerPays();
        this.elements.button.addEventListener('pointerenter', precharger, { passive: true });
        this.elements.button.addEventListener('touchstart', precharger, { passive: true });
        this.elements.button.addEventListener('focus', precharger);
      }
    }

    chargerPays() {
      const ul = this.querySelector('ul[data-sdo-pays]');
      if (!ul) return Promise.resolve();
      if (this._sdoPays) return this._sdoPays;
      this._sdoPays = fetch(ul.getAttribute('data-sdo-pays'), { credentials: 'same-origin' })
        .then((r) => {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then((html) => {
          ul.insertAdjacentHTML('afterbegin', html);
          ul.removeAttribute('data-sdo-pays');
          if (this.elements.inputSearch && this.elements.inputSearch.value) {
            this.filter({ target: this.elements.inputSearch });
          }
        })
        .catch((e) => {
          this._sdoPays = null;
          if (window.console) console.warn('Sélecteur pays : liste non chargée', e);
        });
      return this._sdoPays;
    }

    filter(event) {
      const valThis = event.target.value;
      this.elements.panel.querySelectorAll('.disclosure__item').forEach((item) => {
        const text = item.querySelector('.localization-form__country-name').textContent;
        const textMatch = text.toLowerCase().indexOf(valThis.toLowerCase()) > -1;
        textMatch ? item.classList.remove('hide') : item.classList.add('hide');
      });
      const activeItems = this.elements.panel.querySelectorAll('.disclosure__item:not(.hide)');
      const noResultsMessage = this.elements.panel.querySelector('.disclosure__no-results');
      if (!activeItems.length) {
        noResultsMessage.classList.remove('hide');
      } else if (!noResultsMessage.classList.contains('hide')) {
        noResultsMessage.classList.add('hide');
      }
    }

    hidePanel() {
      this.classList.remove('localization-screen-visible');
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.button.classList.remove('disclosure__button--open');
      this.elements.panel.setAttribute('hidden', true);
      if (this.elements.parentClass === 'desktop-localization-wrapper') {
        document.body.classList.remove('overflow-hidden');
      } else {
        document.body.classList.remove('overflow-hidden-mobile');
      }
      document.body.removeEventListener('click', this.onBodyClick);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event, item) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = (item || event.currentTarget).dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.chargerPays();
      this.classList.toggle('localization-screen-visible');
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
      this.elements.button.classList.toggle('disclosure__button--open');
      if (this.elements.parentClass === 'desktop-localization-wrapper') {
        document.body.classList.add('overflow-hidden');
      } else {
        document.body.classList.add('overflow-hidden-mobile');
      }
      document.body.addEventListener('click', this.onBodyClick);
    }

    handleBodyClick(evt) {
      const target = evt.target;
      const closestForm = target.closest('localization-form');
      if (target !== this && !target.closest('localization-form')) {
        this.hidePanel();
      } else if (closestForm !== this) {
        this.hidePanel();
      }
    }
  });
}
